module.exports = __webpack_public_path__ + "img/3-star-500.54b0617b.png";